/**
 * @generated SignedSource<<c7c4e58e4174ec8110db2f030ecbb82c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NovaModelLifecycleState = "ACTIVE" | "DEPRECATED" | "RETIRED" | "%future added value";
export type NovaVariableLifecycleState = "ACTIVE" | "DEPRECATED" | "REMOVED" | "%future added value";
export type NovaVariableScope = "TASK" | "PROJECT_CONTEXT" | "FILES" | "%future added value";
export type NovaStudioPage_Query$variables = {};
export type NovaStudioPage_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly novaAgentCatalogue: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
      readonly isUncategorised: boolean | null;
      readonly agents: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly categoryId: string | null;
            readonly title: string | null;
            readonly description: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null> | null;
    readonly novaVariableLibrary: {
      readonly variables: ReadonlyArray<{
        readonly token: string | null;
        readonly scope: NovaVariableScope | null;
        readonly description: string | null;
        readonly lifecycleState: NovaVariableLifecycleState | null;
      } | null> | null;
      readonly removedVariables: ReadonlyArray<{
        readonly token: string | null;
        readonly scope: NovaVariableScope | null;
        readonly description: string | null;
        readonly lifecycleState: NovaVariableLifecycleState | null;
      } | null> | null;
    } | null;
    readonly novaModels: {
      readonly models: ReadonlyArray<{
        readonly modelId: string | null;
        readonly displayName: string | null;
        readonly hint: string | null;
        readonly lifecycleState: NovaModelLifecycleState | null;
      } | null> | null;
      readonly defaultModelId: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"MissionControlHeader_viewer">;
  } | null;
};
export type NovaStudioPage_Query = {
  variables: NovaStudioPage_Query$variables;
  response: NovaStudioPage_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUncategorised",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NovaAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgent",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lifecycleState",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "token",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "scope",
    "storageKey": null
  },
  (v4/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "NovaVariableLibrary",
  "kind": "LinkedField",
  "name": "novaVariableLibrary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaVariable",
      "kind": "LinkedField",
      "name": "variables",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaVariable",
      "kind": "LinkedField",
      "name": "removedVariables",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "NovaModelList",
  "kind": "LinkedField",
  "name": "novaModels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaModel",
      "kind": "LinkedField",
      "name": "models",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modelId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hint",
          "storageKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultModelId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NovaStudioPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MissionControlHeader_viewer"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgentCategory",
            "kind": "LinkedField",
            "name": "novaAgentCatalogue",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": "agents",
                "args": null,
                "concreteType": "NovaAgentConnection",
                "kind": "LinkedField",
                "name": "__NovaStudioCatalogue_agents_connection",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NovaStudioPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgentCategory",
            "kind": "LinkedField",
            "name": "novaAgentCatalogue",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "NovaAgentConnection",
                "kind": "LinkedField",
                "name": "agents",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": "agents(first:1000)"
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "NovaStudioCatalogue_agents",
                "kind": "LinkedHandle",
                "name": "agents"
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7f4e5a1be59abd2679a8fc847e7abf9b",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": null
        }
      ]
    },
    "name": "NovaStudioPage_Query",
    "operationKind": "query",
    "text": "query NovaStudioPage_Query {\n  viewer {\n    actualPersonId\n    ...MissionControlHeader_viewer\n    novaAgentCatalogue {\n      id\n      name\n      isUncategorised\n      agents(first: 1000) {\n        edges {\n          node {\n            id\n            name\n            categoryId\n            title\n            description\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    novaVariableLibrary {\n      variables {\n        token\n        scope\n        description\n        lifecycleState\n      }\n      removedVariables {\n        token\n        scope\n        description\n        lifecycleState\n      }\n    }\n    novaModels {\n      models {\n        modelId\n        displayName\n        hint\n        lifecycleState\n      }\n      defaultModelId\n    }\n    id\n  }\n}\n\nfragment MissionControlHeader_viewer on Viewer {\n  email\n  actualPersonId\n  firstName\n  lastName\n  company {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ab8abedcf8dfc8d8191e923afcd364d";

export default node;
